import { action } from 'mobx';
import { API, APIError, APIPaginatedResponse, APIResponse, getEmptyPaginatedResponse } from '../types';
import { PlaylistGroupPlaylistSchema, PlaylistSchema, TrackSchema } from '../../../types/schema';

export class PlaylistAPIController extends API {
  @action
  addTrackToPlaylist = async (user: string, playlist: string, track: string) => {
    const url = `/user/${user}/playlists/${playlist}`;
    const body = JSON.stringify({ track_id: track });
    const resp = await this.request.post({ url, body });

    return await resp.json();
  };

  @action
  removeTrackFromPlaylist = async (user: string, playlist: string, track: string) => {
    const url = `/user/${user}/playlists/${playlist}`;
    const body = JSON.stringify({ track_id: track });
    const resp = await this.request.del({ url, body });

    return await resp.json();
  };

  @action
  getTracks = async (
    user: string,
    playlist: string,
    page = 1,
    perPage = 25,
  ): Promise<APIPaginatedResponse<Array<TrackSchema>>> => {
    const url = `/user/${user}/playlists/${playlist}?page=${page}&perPage=${perPage}`;
    try {
      const response = await this.request.get({ url });
      await APIError.checkResponse(response);
      const json = await response.json();

      this.cache.addTracks(json.data);

      return json;
    } catch {
      return getEmptyPaginatedResponse();
    }
  };

  @action
  async getFavourites(
    user: string,
    page = 1,
    perPage = 25,
  ): Promise<APIPaginatedResponse<Array<PlaylistGroupPlaylistSchema>>> {
    const url = `/user/${user}/favourites/playlists?page=${page}&perPage=${perPage}`;
    try {
      const response = await this.request.get({ url });
      await APIError.checkResponse(response);
      return await response.json();
    } catch {
      return getEmptyPaginatedResponse();
    }
  }

  @action
  async favouritePlaylist(user: string, playlist: string) {
    const url = `/user/${user}/favourites/playlists`;
    const body = JSON.stringify({ playlist_uuid: playlist });
    const response = await this.request.post({ url, body });
    await APIError.checkResponse(response);
    return await response.json();
  }

  @action
  async unfavouritePlaylist(user: string, playlist: string) {
    const url = `/user/${user}/favourites/playlists`;
    const body = JSON.stringify({ playlist_uuid: playlist });
    const response = await this.request.del({ url, body });
    await APIError.checkResponse(response);
    return await response.json();
  }
}
